import { Plugin, PluginKey } from 'prosemirror-state'
import { ReviewView } from './ReviewView'
import { Decoration, DecorationSet } from 'prosemirror-view'
import { Node } from 'prosemirror-model'
import Styles from './Review.module.scss'
import { schema } from 'prose-core'
import { type Review } from 'stores/Review'
import cx from 'classnames'

type InitConfig = {
  store: Review
}

export type ReviewPluginState = {
  store: Review
}

type DecorationAttrs = { class: string; title?: string }

const PLUGIN_KEY = new PluginKey<ReviewPluginState>('review')
export const reviewKey = PLUGIN_KEY

export function review(config: InitConfig) {
  return new Plugin<ReviewPluginState>({
    key: reviewKey,
    state: {
      init(_, __) {
        const { store } = config
        return { store }
      },
      apply(tr, currentPluginState) {
        return currentPluginState
      },
    },
    view(view) {
      return new ReviewView(view)
    },
    props: {
      decorations: (editorState) => {
        const { doc } = editorState
        const { store } = reviewKey.getState(editorState) as ReviewPluginState
        const { selectedRequest } = store

        const decorations: Decoration[] = []
        doc.descendants((node, pos) => {
          if (isReview(node)) {
            const isReviewSelected = selectedRequest?.section_uuid && isSelected(node, selectedRequest?.section_uuid)
            const decorationAttrs: DecorationAttrs = {
              class: cx(Styles.reviewMark, { [Styles.selected]: isReviewSelected }),
            }
            if (isReviewSelected && selectedRequest) {
              decorationAttrs.title = `Review ${selectedRequest.key}`
            }
            decorations.push(Decoration.inline(pos, pos + node.nodeSize, decorationAttrs))
          }
        })
        return DecorationSet.create(doc, decorations)
      },
    },
  })
}

function isSelected(node: Node, reviewUUID: string | undefined) {
  if (!reviewUUID) return false
  return node.marks.some((mark) => mark.attrs.uuid === reviewUUID)
}

function isReview(node: Node) {
  return node.marks.some((mark) => mark.type === schema.marks.review)
}
